import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import axios from "../apis/axios";
import { getToken } from "../utilities";

function useGet({ url, initialParams = {}, onSuccess = () => {}, onError = () => {}, enabled = true }) {
  const [paramsObject, setParamsObject] = useState(initialParams);

  const fetchData = async () => {
    // Convert paramsObject to query string
    const queryParams = new URLSearchParams(paramsObject).toString();
    const requestUrl = queryParams ? `/${url}?${queryParams}` : `/${url}`;

    const response = await axios({
      method: "GET",
      url: requestUrl,
      headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
    });

    return response.data;
  };

  const data = useQuery([url, paramsObject], fetchData, {
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (data) => {
      onSuccess(data);
    },
    onError: (err) => {
      onError(err);
    },
    enabled: enabled,
  });

  return { paramsObject, setParamsObject, data };
}

export default useGet;
